import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
// TODO: Re-add below
// import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { DirtyErrorStateMatcherDirective } from './directives/dirty-error-state-matcher.directive';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MapState, PaymentKeyState } from '../app/components/shared/map.state';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import {
  HeaderComponent,
  OrderDetailsDialogComponent,
} from './components/header/header.component';
import { PortalComponent } from './components/portal/portal.component';
import { WalletComponent } from './components/afripay/wallet/wallet.component';
import { SessionService } from './services/session/session.service';
import { SessionDataApi } from './api/session/session.api.class';
import { PaymentService } from './services/payment/payment.service';
import { PaymentApi } from './api/payment/payment.api.class';
import { TransactionApi } from './api/transaction/transaction.api.class';
import { ErrorHandlingComponent } from './components/error-handling/error-handling.component';
import { InterceptorService } from './services/interceptor/interceptor.service';

import { CardApi } from './api/card/card.api.class';

import { SecureEftApi } from '../app/api/eft-secure/eft-secure.api.class';
import { ProcessingComponent } from '../app/components/afripay/processing/processing.component';
import { CardComponent } from './components/card/card.component';
import { MobicredComponent } from './components/mobicred/mobicred/mobicred.component';
import { MobicredLoginComponent } from './components/mobicred/mobicred-login/mobicred-login.component';
import { MobicredOtpComponent } from './components/mobicred/mobicred-otp/mobicred-otp.component';
import { SecureEftTransactionComponent } from '../app/components/secure-eft/transaction/transaction.component';
import { EftComponent } from './components/secure-eft/base/eft.component';
import { OttVoucherComponent } from './components/ott-voucher/ott-voucher.component';
import { VoucherInputComponent } from './components/ott-voucher/voucher-input/voucher-input.component';
import { VoucherProcessingComponent } from './components/ott-voucher/voucher-processing/voucher-processing.component';
import { OttVoucherApi } from './api/ott-voucher/ott-voucher.api.class';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AfripayComponent } from './components/afripay/afripay.component';
import { MobicredApi } from './api/mobicred/mobicred.api.class';
import {
  ErrorStateMatcher,
  ShowOnDirtyErrorStateMatcher,
} from '@angular/material/core';
import { IMaskModule } from 'angular-imask';
import { CardAddComponent } from './components/card/add/add.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { environment } from '../../src/environments/environment';
import { GoogleAnalyticsService } from './services/google-analytics/google-analytics.service';
import { ForwardingService } from './services/forwarding/forwarding.service';
import { ForwardingApi } from './api/forwarding/forwarding.api.class';
import { PaymentsComponent } from './components/payments/payments.component';
import { CardSelectionComponent } from './components/card-selection/card-selection.component';
import { OtherSelectionComponent } from './components/other-selection/other-selection.component';
import { TransactionStatusComponent } from './components/transaction-status/transaction-status.component';
import { BottomSheetCardDeleteConfirm } from './components/card-selection/card-selection.component';
import { PollingCallbackApiClass } from './api/polling-callback/polling-callback.api.class';
import { OverlayModule } from '@angular/cdk/overlay';

// Quick Link
import { QuicklinkModule } from 'ngx-quicklink';
import { TdsComponent } from './components/card/tds/tds.component';
import { FileApiClass } from './api/File/file.api.class';
import { FileService } from './services/file-service/file.service';
import { ZapperComponent } from './components/zapper/zapper.component';
import { ZapperApi } from './api/zapper/zapper.api.class';
import { MasterPassComponent } from './components/master-pass/master-pass.component';
import { ValidateComponent } from './components/master-pass/validate/validate.component';
import { MasterPassService } from './services/master-pass/master-pass.service';
import { MasterPassApi } from './api/master-pass/master-pass.api.class';
import { SwitchpayComponent } from './components/switchpay/switchpay.component';
import { SwitchpayCallbackComponent } from './components/switchpay/callback/switchpay-callback.component';
import { SwitchpayService } from './services/switchpay/switchpay.service';
import { SwitchpayApi } from './api/switchpay/switchpay.api.class';
import { CountdownModule } from 'ngx-countdown';
import { ClickToPayComponent } from './components/click-to-pay/click-to-pay.component';
import { VisaClickToPayComponent } from './components/click-to-pay/visa-click-to-pay/visa-click-to-pay.component';
import { VisaApiClass } from './api/visa/visa.api.class';
import { VisaService } from './services/visa/visa.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { ClickToPayService } from './services/click-to-pay/click-to-pay.service';
import { ClickToPayApiClass } from './api/click-to-pay/click-to-pay.api.class';
import { InitClickToPayComponent } from './components/click-to-pay/init-click-to-pay/init-click-to-pay.component';
import { AdumoeftComponent } from './components/adumoeft/initiate/adumoeft.component';
import { AdumoeftService } from './services/adumoeft/adumoeft.service';
import { AdumoeftApi } from './api/adumoeft/adumoeft.api.class';
import { AdumoeftCallbackComponent } from './components/adumoeft/callback/adumoeft-callback.component';
import { OzowComponent } from './components/ozow/initiate/ozow.component';
import { OzowCallbackComponent } from './components/ozow/callback/ozow-callback.component';
import { OzowService } from './services/ozow/ozow.service';
import { OzowEftApi } from './api/ozow/ozow.api.class';
import { InstalmentComponent } from './components/card/instalment/instalment.component';
import { ConfirmSelectionComponent } from './components/card/confirm-selection/confirm-selection.component';
import { PaymentPageComponent } from './components/payment-page/payment-page.component';
import { ChannelVirtualComponent } from './components/channel-virtual/channel-virtual.component';
import { ChannelPaymentPageComponent } from './components/channel-payment-page/channel-payment-page.component';
import { PaymentPageApi } from './api/payment-page/payment.page.api.class';
import { ChannelVirtualVersionTwoComponent } from './components/channel-virtual-version-two/channel-virtual-version-two.component';
import { MasterpassComponent } from './components/channel-virtual-version-two/masterpass/masterpass.component';
import { CommonModule } from '@angular/common';
import { PortalComponent as PortalV2Component } from './components/channel-virtual-version-two/portal/portal.component';
import { PaymentsComponent as PaymentsV2Component } from './components/channel-virtual-version-two/portal/payments/payments.component';
import { EftComponent as EftV2Component } from './components/channel-virtual-version-two/eft/eft.component';
import { SecureEftTransactionComponent as SecureEftTransactionV2Component } from './components/channel-virtual-version-two/eft/secure-eft-transaction/secure-eft-transaction.component';
import { MobicredComponent as MobicredV2Component } from './components/channel-virtual-version-two/mobicred/mobicred.component';
import { MobicredLoginComponent as MobicredLoginV2Component } from './components/channel-virtual-version-two/mobicred/mobicred-login/mobicred-login.component';
import { MobicredOtpComponent as MobicredOtpV2Component } from './components/channel-virtual-version-two/mobicred/mobicred-otp/mobicred-otp.component';
import { OttVoucherComponent as OttVoucherV2Component } from './components/channel-virtual-version-two/ott-voucher/ott-voucher.component';
import { VoucherInputComponent as VoucherInputV2Component } from './components/channel-virtual-version-two/ott-voucher/voucher-input/voucher-input.component';
import { VoucherProcessingComponent as VoucherProcessingV2Component } from './components/channel-virtual-version-two/ott-voucher/voucher-processing/voucher-processing.component';
import { CardComponent as CardV2Component } from './components/channel-virtual-version-two/card/card.component';
import { CardAddComponent as CardAddV2Component } from './components/channel-virtual-version-two/card/card-add/card-add.component';
import { ConfirmSelectionComponent as ConfirmSelectionV2Component } from './components/channel-virtual-version-two/card/confirm-selection/confirm-selection.component';
import { InstalmentComponent as InstalmentV2Component } from './components/channel-virtual-version-two/card/instalment/instalment.component';
import { TdsComponent as TdsV2Component } from './components/channel-virtual-version-two/card/tds/tds.component';
import { MasterpassComponent as MasterpassV2Component } from './components/channel-virtual-version-two/masterpass/masterpass.component';
import { ValidateComponent as ValidateV2Component } from './components/channel-virtual-version-two/masterpass/validate/validate.component';
import { SwitchpayComponent as SwitchpayV2Component } from './components/channel-virtual-version-two/switchpay/switchpay.component';
import { SwitchpayCallbackComponent as SwitchpayCallbackV2Component } from './components/channel-virtual-version-two/switchpay/switchpay-callback/switchpay-callback.component';
import { ZapperComponent as ZapperV2Component } from './components/channel-virtual-version-two/zapper/zapper.component';
import { OzowComponent as OzowV2Component } from './components/channel-virtual-version-two/ozow/ozow.component';
import { OzowCallbackComponent as OzowCallbackV2Component } from './components/channel-virtual-version-two/ozow/ozow-callback/ozow-callback.component';
import { ErrorHandlingComponent as ErrorHandlingV2Component } from './components/channel-virtual-version-two/error-handling/error-handling.component';
import { NotFoundComponent as NotFoundV2Component } from './components/channel-virtual-version-two/not-found/not-found.component';
import { AdumoEftComponent as AdumoEftPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/adumo-eft/adumo-eft.component';
import { DebitCreditCardComponent as DebitCreditCardPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/debit-credit-card/debit-credit-card.component';
import { GooglePayComponent as GooglePayPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/google-pay/google-pay.component';
import { ApplePayComponent as ApplePayPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/apple-pay/apple-pay.component';
import { MasterpassComponent as MasterpassPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/masterpass/masterpass.component';
import { MobicredComponent as MobicredPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/mobicred/mobicred.component';
import { OttVoucherComponent as OttVoucherPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/ott-voucher/ott-voucher.component';
import { ZapperComponent as ZapperPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/zapper/zapper.component';
import { OzowComponent as OzowPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/ozow/ozow.component';
import { VisaClickToPayComponent as VisaClickToPayPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/visa-click-to-pay/visa-click-to-pay.component';
import { AdumoEftComponent as AdumoEftPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/adumo-eft/adumo-eft.component';
import { DebitCreditCardComponent as DebitCreditCardPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/debit-credit-card/debit-credit-card.component';
import { GooglePayComponent as GooglePayPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/google-pay/google-pay.component';
import { ApplePayComponent as ApplePayPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/apple-pay/apple-pay.component';
import { MasterpassComponent as MasterpassPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/masterpass/masterpass.component';
import { MobicredComponent as MobicredPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/mobicred/mobicred.component';
import { OttVoucherComponent as OttVoucherPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/ott-voucher/ott-voucher.component';
import { ZapperComponent as ZapperPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/zapper/zapper.component';
import { OzowComponent as OzowPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/ozow/ozow.component';
import { VisaClickToPayComponent as VisaClickToPayPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/visa-click-to-pay/visa-click-to-pay.component';
import { LifestyleRewardsComponent as LifestyleRewardsV2Component } from './components/channel-virtual-version-two/lifestyle-rewards/lifestyle-rewards.component';
import { LifestyleRewardsLoginComponent as LifestyleRewardsLoginV2Component } from './components/channel-virtual-version-two/lifestyle-rewards/lifestyle-rewards-login/lifestyle-rewards-login.component';
import { LifestyleRewardsComponent as LifestyleRewardsPaymentMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/lifestyle-rewards/lifestyle-rewards.component';
import { LifestyleRewardsComponent as LifestyleRewardsPaymentPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/lifestyle-rewards/lifestyle-rewards.component';
import { TransationStatusComponent as TransationStatusV2Component } from './components/channel-virtual-version-two/transation-status/transation-status.component';
import { MultiCardOptionComponent as MultiCardOptionV2Component } from './components/channel-virtual-version-two/card/multi-card-option/multi-card-option.component';
import { GooglePaySelectedComponent } from './components/channel-virtual-version-two/card/google-pay-selected/google-pay-selected.component';
import { ApplePaySelectedComponent } from './components/channel-virtual-version-two/card/apple-pay-selected/apple-pay-selected.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { GooglePayService } from './services/google-pay.service';
import { AnalyticsService } from './services/analytics/analytics.service';
import { LifestyleRewardsApi } from './api/lifestyle-rewards/lifestyle-rewards.api.class';
import { LifestyleRewardsService } from './services/lifestyle-rewards/lifestyle-rewards.service';
import { AnalyticsModule } from './analytics/analytics.module';
import { PayJustNowComponent as PayJustNowMethodComponent } from './components/channel-virtual-version-two/portal/payments/methods/pay-just-now/pay-just-now.component';
import { PayJustNowComponent as PayJustNowPromotionComponent } from './components/channel-virtual-version-two/portal/payments/promotions/pay-just-now/pay-just-now.component';
import { PayJustNowComponent as PayJustNowV2Component } from './components/channel-virtual-version-two/pay-just-now/pay-just-now.component';
import { PayJustNowService } from './services/pay-just-now/pay-just-now.service';
import { PayJustNowApi } from './api/pay-just-now/pay-just-now-api';
import { CallbackComponent as PayJustNowCallbackComponent } from './components/channel-virtual-version-two/pay-just-now/callback/callback.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PortalComponent,
    WalletComponent,
    OrderDetailsDialogComponent,
    ErrorHandlingComponent,

        CardComponent,
        MobicredComponent,
        MobicredLoginComponent,
        MobicredOtpComponent,
        SecureEftTransactionComponent,
        EftComponent,
        OttVoucherComponent,
        VoucherInputComponent,
        VoucherProcessingComponent,
        AfripayComponent,
        ProcessingComponent,
        TransactionStatusComponent,
        DirtyErrorStateMatcherDirective,
        CardAddComponent,
        NotFoundComponent,
        PaymentsComponent,
        OtherSelectionComponent,
        CardSelectionComponent,
        BottomSheetCardDeleteConfirm,
        TdsComponent,
        ZapperComponent,
        MasterPassComponent,
        SwitchpayComponent,
        SwitchpayCallbackComponent,
        ValidateComponent,
        ClickToPayComponent,
        VisaClickToPayComponent,
        InitClickToPayComponent,
        AdumoeftComponent,
        AdumoeftCallbackComponent,
        OzowComponent,
        OzowCallbackComponent,
        InstalmentComponent,
        ConfirmSelectionComponent,
        PaymentPageComponent,
        ChannelVirtualComponent,
        ChannelPaymentPageComponent,
        ChannelVirtualVersionTwoComponent,
        MasterpassComponent,
        ChannelVirtualVersionTwoComponent,
        NotFoundV2Component,
        ErrorHandlingV2Component,
        OzowCallbackV2Component,
        OzowV2Component,
        ZapperV2Component,
        SwitchpayCallbackV2Component,
        SwitchpayV2Component,
        ValidateV2Component,
        MasterpassV2Component,
        TdsV2Component,
        InstalmentV2Component,
        ConfirmSelectionV2Component,
        CardAddV2Component,
        CardV2Component,
        VoucherProcessingV2Component,
        VoucherInputV2Component,
        OttVoucherV2Component,
        MobicredOtpV2Component,
        PortalV2Component,
        PaymentsV2Component,
        EftV2Component,
        SecureEftTransactionV2Component,
        MobicredV2Component,
        MobicredLoginV2Component,
        AdumoEftPaymentMethodComponent,
        DebitCreditCardPaymentMethodComponent,
        GooglePayPaymentMethodComponent,
        ApplePayPaymentMethodComponent,
        ZapperPaymentMethodComponent,
        OzowPaymentMethodComponent,
        OttVoucherPaymentMethodComponent,
        MobicredPaymentMethodComponent,
        MasterpassPaymentMethodComponent,
        VisaClickToPayPaymentMethodComponent,
        AdumoEftPaymentPromotionComponent,
        DebitCreditCardPaymentPromotionComponent,
        GooglePayPaymentPromotionComponent,
        ApplePayPaymentPromotionComponent,
        MasterpassPaymentPromotionComponent,
        MobicredPaymentPromotionComponent,
        OttVoucherPaymentPromotionComponent,
        ZapperPaymentPromotionComponent,
        OzowPaymentPromotionComponent,
        VisaClickToPayPaymentPromotionComponent,
        LifestyleRewardsV2Component,
        LifestyleRewardsLoginV2Component,
        LifestyleRewardsPaymentMethodComponent,
        LifestyleRewardsPaymentPromotionComponent,
        TransationStatusV2Component,
        MultiCardOptionV2Component,
        ChannelPaymentPageComponent,
        GooglePaySelectedComponent,
        ApplePaySelectedComponent,
        PayJustNowV2Component,
        PayJustNowMethodComponent,
        PayJustNowPromotionComponent,
        PayJustNowCallbackComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        MatGridListModule,
        MatIconModule,
        MatSidenavModule,
        MatListModule,
        MatButtonModule,
        MatToolbarModule,
        BrowserAnimationsModule,
        HttpClientModule,
        MatCardModule,
        MatTabsModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatSnackBarModule,
        MatTableModule,
        MatPaginatorModule,
        FormsModule,
        MatBottomSheetModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatSelectModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        IMaskModule,
        QuicklinkModule,
        OverlayModule,
        // NgxIntlTelInputModule,
        CountdownModule,
        NgxsModule.forRoot([
            MapState,
            PaymentKeyState/* ,
      PaymentStepState */
        ], {
            developmentMode: !environment.production
        }),
        MatTooltipModule,
        MatRadioModule,
        GooglePayButtonModule,
        AnalyticsModule,
        MatMenuModule
    ],
  // tslint:disable-next-line: max-line-length
  providers: [
    PaymentPageApi,
    SessionService,
    FileApiClass,
    FileService,
    SessionDataApi,
    PollingCallbackApiClass,
    ForwardingService,
    ForwardingApi,
    PaymentService,
    PaymentApi,
    TransactionApi,
    SecureEftApi,
    OttVoucherApi,
    GoogleAnalyticsService,
    MobicredApi,
    CardApi,
    ZapperApi,
    MasterPassService,
    MasterPassApi,
    SwitchpayService,
    SwitchpayApi,
    ClickToPayService,
    ClickToPayApiClass,
    AdumoeftService,
    AdumoeftApi,
    OzowService,
    OzowEftApi,
    GooglePayService,
    LifestyleRewardsApi,
    LifestyleRewardsService,
    PayJustNowService,
    PayJustNowApi,
    {
      useClass: InterceptorService,
      provide: HTTP_INTERCEPTORS,
      multi: true,
    },
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher },
    AnalyticsService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
